import {
  enabledDepth,
  labelAt,
} from "../../Subjects/detail/hierarchyUtils"
import {
  LevelFieldErrors,
  LevelFieldValues,
} from "../components/LevelSelectors"

/** Topic (1) and subtopic (2) are required; chapter (3) and section (4) are optional. */
export const REQUIRED_QUESTION_HIERARCHY_LEVELS = 2

export const isQuestionHierarchyLevelRequired = (
  level: number,
  depth: number
): boolean => level <= REQUIRED_QUESTION_HIERARCHY_LEVELS && level <= depth

export const validateQuestionHierarchyLevels = (
  levels: LevelFieldValues,
  labels: string[],
  messagePrefix: "required" | "select" = "required"
): LevelFieldErrors => {
  const depth = enabledDepth(labels)
  const levelErrors: LevelFieldErrors = {}
  const values = [levels.level_1, levels.level_2, levels.level_3, levels.level_4]

  for (let level = 1; level <= REQUIRED_QUESTION_HIERARCHY_LEVELS; level += 1) {
    if (level > depth) continue
    if (values[level - 1]) continue

    const name = labelAt(labels, level).toLowerCase()
    levelErrors[`level_${level}` as keyof LevelFieldErrors] =
      messagePrefix === "select"
        ? `Please select a ${name}.`
        : `${labelAt(labels, level)} is required.`
  }

  return levelErrors
}

export const hasLevelFieldErrors = (errors: LevelFieldErrors) =>
  Object.values(errors).some(Boolean)
